// Static Tailwind class maps (no dynamic class names — Tailwind must see full strings).
const COLOURS = {
  emerald: { bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", dot: "bg-emerald-500" },
  blue: { bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200", dot: "bg-blue-500" },
  sky: { bg: "bg-sky-50", text: "text-sky-700", border: "border-sky-200", dot: "bg-sky-500" },
  rose: { bg: "bg-rose-50", text: "text-rose-700", border: "border-rose-200", dot: "bg-rose-500" },
  amber: { bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200", dot: "bg-amber-500" },
  orange: { bg: "bg-orange-50", text: "text-orange-700", border: "border-orange-200", dot: "bg-orange-500" },
  purple: { bg: "bg-purple-50", text: "text-purple-700", border: "border-purple-200", dot: "bg-purple-500" },
  indigo: { bg: "bg-indigo-50", text: "text-indigo-700", border: "border-indigo-200", dot: "bg-indigo-500" },
  pink: { bg: "bg-pink-50", text: "text-pink-700", border: "border-pink-200", dot: "bg-pink-500" },
  teal: { bg: "bg-teal-50", text: "text-teal-700", border: "border-teal-200", dot: "bg-teal-500" },
  slate: { bg: "bg-slate-100", text: "text-slate-600", border: "border-slate-200", dot: "bg-slate-400" },
};

const ALIAS = {
  green: "emerald", emerald: "emerald",
  blue: "blue", sky: "sky", cyan: "sky",
  red: "rose", rose: "rose",
  amber: "amber", yellow: "amber",
  orange: "orange",
  purple: "purple", violet: "purple",
  indigo: "indigo",
  pink: "pink",
  teal: "teal",
  grey: "slate", gray: "slate", slate: "slate", black: "slate",
};

export function colourClasses(token) {
  if (!token) return COLOURS.slate;
  const base = String(token).split("-")[0].toLowerCase();
  return COLOURS[ALIAS[base] || "slate"];
}
